module.exports = __webpack_public_path__ + "resource/img/selectMateriel.ee9a9c47.png";